import { useState, useEffect, forwardRef, useCallback } from   'react';
import PropTypes from 'prop-types';
import { useParams, useNavigate } from 'react-router-dom';
import MenuEnlacesDX from './Componentes/MenuEnlacesDX';
import HeaderDXReloj from './Componentes/HeaderDXReloj';
import SeccionPageHeader from '../Utils/SeccionPageHeader';
import CargandoSpinner from '../Utils/CargandoSpinner';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import { useAuth } from '../../Auth/AuthContext';
import SweetAlert2 from 'react-sweetalert2';
import { Tooltip } from 'react-tooltip';  
import apiService from '../../Auth/apiService';
import { useForm, Controller } from 'react-hook-form';
import { FaCalendar } from 'react-icons/fa';
import moment from 'moment';
import { getMunicipiosDX, saveMunicipiosDX } from '../Utils/indexedDBUtils';

const CustomInput = forwardRef(function CustomInput({ value, onClick }, ref) {
    const handleKeyDown = (e) => {
        if (e.key === 'Enter' || e.key === ' ') {
            e.preventDefault();
            onClick(e);
        }
    };
    return (
        <button
            type="button"
            className="custom-input"
            onClick={onClick}
            onKeyDown={handleKeyDown}
            ref={ref}
            aria-label="Seleccionar fecha"
            style={{ display: 'flex', alignItems: 'center', border: 'none', background: 'none', padding: 0 }}
        >
            <input value={value} readOnly className='widthCalendar' tabIndex={-1} aria-readonly="true" style={{ pointerEvents: 'none', background: 'transparent', border: 'none' }} />
            <FaCalendar />
        </button>
    );
});



export default function DXAgregarIntegrante() {
    const { token, rol } = useAuth();
    const { iddx } = useParams();
    const { idpersona } = useParams();
    const { idrecepcion } = useParams();
    const [Cargando, setCargando] = useState(false);
    const [tiposDocumento, setTiposDocumento] = useState([]);
    const [parentescosFiltro, setParentescosFiltro] = useState([]);
    const [tiposDocumentoExtranjeria, setTiposDocumentoExtranjeria] = useState([]);
    const Navigate = useNavigate();
    const [swalProps, setSwalProps] = useState({});
    const [parentescos, setParentescos] = useState([]);
    const [pendingResetData, setPendingResetData] = useState(null);
    const [paises, setPaises] = useState([]);
    const [sexos, setSexos] = useState([]);
    const [gestantes, setGestantes] = useState([]);
    const [etnias, setEtnias] = useState([]);
    const [discapacidadCausas, setDiscapacidadCausas] = useState([]);
    const [enfermedades, setEnfermedades] = useState([]);
    const [condicionesRiesgo, setCondicionesRiesgo] = useState([]);
    const [ingresosProvenientes, setIngresosProvenientes] = useState([]);
    const [municipios, setMunicipios] = useState([]);
    const [departamentosSisben, setDepartamentosSisben] = useState([]);
    const [municipiosSisben, setMunicipiosSisben] = useState([]);
    const [departamentosFosyga, setDepartamentosFosyga] = useState([]);
    const [municipiosFosyga, setMunicipiosFosyga] = useState([]);
    const [orientacionesSexuales, setOrientacionesSexuales] = useState([]);
    const [identidadesGenero, setIdentidadesGenero] = useState([]);
    const [regimenFosyga, setRegimenFosyga] = useState([]);
    const [cantidadIntegrantes, setCantidadIntegrantes] = useState(0);
    const [btnGuardarDisabled, setBtnGuardarDisabled] = useState(false);
    const [fechaInicioAtencion, setFechaInicioAtencion] = useState(null);
    const { watch, handleSubmit, register, setValue, reset, control, formState: { errors }} = useForm({ 
        defaultValues: {
            id: '',
            iddx: '',
            chkfuerza_mayor: false,
            generabaingresos: false,
        } 
    }
    );
    function CalcularEdad(date){
            setValue('edad', moment().diff(date, 'years'));
        }
    const Mensaje = (title, text) => {
        setSwalProps({
            show: true,
            title: title,
            html: text,
        });
    };
    const getMunicipiosDXData = useCallback(async () => {
        const cachedmunicipiosDX = await getMunicipiosDX();
        if (cachedmunicipiosDX) {
            setMunicipios(cachedmunicipiosDX);
        } else {
            // If not in IndexedDB, fetch from the API
            const municipios = await fetchMunicipiosDX();
            if (municipios) {
                setMunicipios(municipios);
                await saveMunicipiosDX(municipios); // Save the result to IndexedDB
            }
        }
    }, []);
    function checkCausaDiscapacidad(value){
        if (
            !value &&
            !watch("dif_2_5_1_1_ceguera") && 
            !watch("dif_2_5_1_2_sordera") && 
            !watch("dif_2_5_1_3_mudez") && 
            !watch("dif_2_5_1_4_cognitiva_mental") && 
            !watch("dif_2_5_1_5_paralisisausencia_miemb_sup") && 
            !watch("dif_2_5_1_6_paralisisausencia_miemb_inf")) {
            setValue("dif_2_5_2_causa_discapacidad", '');
            setValue("obs_discapacidad", '');
        }
    }    
    async function fetchMunicipiosDX() {
        const url = '/diagnostico/obtenermunicipiosdx';
        return apiService.get(url, token)
            .then((response) => {
                if (Array.isArray(response.data.municipiosdx)) {
                    return response.data.municipiosdx;   
                }
                return null;
            })
            .catch((error) => {
                console.error('Error fetching municipios:', error);
                return null;
            });
    }
    function validarFuerzaMayor(date) {
        const fechaActual = new Date().toLocaleDateString('en-CA');
        const fechaFuerzaMayor = new Date(date).toLocaleDateString('en-CA');
        const diffInDays = moment(fechaActual).diff(moment(fechaFuerzaMayor), 'days');
        if (diffInDays > 90) {
            setValue('chkfuerza_mayor', true);
            setValue('fuerza_mayor_', "");
        } else {
            setValue('chkfuerza_mayor', false);
            setValue('fuerza_mayor', "");
        }
    }
    const formatDateFields = (data) => {
        const dateFields = [
            'fecha_nacimiento',
            'vict_4_1_1_desaparicion_forzada',
            'vict_4_1_2_secuestro',
            'vict_4_1_3_desplazamiento_forzado',
            'vict_4_1_4_homicidio',
            'vict_4_1_5_masacre',
            'vict_4_1_6_tortura_o_tratos_inhumanos_degradantes',
            'vict_4_1_7_lesiones_permanentes_o_transitorias',
            'vict_4_1_8_minas_antipersonal_municiones_sin_explotar',
            'vict_4_1_9_delitos_contra_la_libertad_y_la_integridad_sexual',
            'vict_4_1_10_1_intento_de_reclutamiento',
            'vict_4_1_10_2_reclutamiento_y_utilizacion',
            'vict_4_1_11_acto_terrorista',
            'vict_4_1_12_amenaza',
            'vict_4_1_13_despojo_y_abandono_forzado_de_tierras'
        ];
        dateFields.forEach(field => {
            if (moment(data[field]).isValid()) {
                data[field] = moment(data[field]).format('YYYY-MM-DD');
            } else {
                data[field] = null;
            }
        });
    };
    const handleApiError = (error) => {
        if (error.status === 422) {
            Mensaje('Guardar', JSON.stringify(error.response.data.errors));
        } else if (error.status === 409) {
            Mensaje('Guardar', JSON.stringify(error.response.data));
        }
        console.error('Error fetching data:', error);
    };
    const onSubmit = async (data) => {
        setBtnGuardarDisabled(true);
        setCargando(true);
        const url = '/diagnostico/integrante/guardarintegrante';
        try {
            formatDateFields(data);
            const response = await apiService.post(url, data, token);
            if (response.status === 200) {
                Mensaje('Guardar', JSON.stringify(response.data.message));
                irAHogar();
            }
        } catch (error) {
            handleApiError(error);
        } finally {
            setCargando(false);
            setBtnGuardarDisabled(false);
        }
    };
    function irAHogar(){
        Navigate(`/dx/hogar/${iddx}/${idrecepcion}`);
    }
    
    const formatVictimDate = (value) => {
        value = value == '1900-01-01T00:00:00.000Z' ? null : value;
        return moment(value?.split('T')[0], 'YYYY-MM-DD', true).isValid()
            ? moment.utc(value).set({ hour: 12, minute: 0, second: 0 }).format('YYYY-MM-DDTHH:mm:ss')
            : null;
    };

    const fillVictimDates = (data, fields) => {
        fields.forEach(field => {
            data[field] = formatVictimDate(data?.[field]);
        });
    };

    const setMunicipiosAndValue = (departamento, municipios, setMunicipios, setValue, municipioField, value) => {
        if (departamento) {
            const nuevosMunicipios = municipios
                .filter((municipio) => municipio.mun_departamentoid === departamento.toString())
                .map((municipio) => ({ id: municipio.id, name: municipio.mun_municipio }));
            setMunicipios(nuevosMunicipios);
            setTimeout(() => {
                setValue(municipioField, value || '');
            }, 0);
        } else {
            setMunicipios([]);
            setValue(municipioField, '');
        }
    };
    const FormReset = useCallback((data) => {
        if (!data) return;

        // 1. Fechas victimizantes
        const victimDateFields = [
            'fecha_nacimiento',
            'vict_4_1_1_desaparicion_forzada',
            'vict_4_1_2_secuestro',
            'vict_4_1_3_desplazamiento_forzado',
            'vict_4_1_4_homicidio',
            'vict_4_1_5_masacre',
            'vict_4_1_6_tortura_o_tratos_inhumanos_degradantes',
            'vict_4_1_7_lesiones_permanentes_o_transitorias',
            'vict_4_1_8_minas_antipersonal_municiones_sin_explotar',
            'vict_4_1_9_delitos_contra_la_libertad_y_la_integridad_sexual',
            'vict_4_1_10_1_intento_de_reclutamiento',
            'vict_4_1_10_2_reclutamiento_y_utilizacion',
            'vict_4_1_11_acto_terrorista',
            'vict_4_1_12_amenaza',
            'vict_4_1_13_despojo_y_abandono_forzado_de_tierras'
        ];
        fillVictimDates(data, victimDateFields);
        
        // 2. País de origen
        const paisOrigen = paises.find((e) => e.pais == data?.pais_origen)?.id?.toString() || '';

        // 3. Reset principal
        reset((prevValues) => ({
            ...prevValues,
            id: data?.id || 0,
            iddx: data?.iddx || '',
            tipodoc: data?.tipodoc,
            tipodocextranjero: data?.tipodocextranjero || '',
            slcintpais: paisOrigen,
            pais_origen: data?.pais_origen || '',
            numdoc: data?.numdoc || '',
            pnombre: data?.pnombre || '',
            snombre: data?.snombre || '',
            papellido: data?.papellido || '',
            sapellido: data?.sapellido || '',
            parentesco: data?.parentesco || '',
            noestaenmedellin: data?.noestaenmedellin || false,
            fecha_nacimiento: data?.fecha_nacimiento || '',
            edad: data?.edad || '',
            sexo: data?.sexo?.toString() || '',
            per_orientacionsexual: data?.per_orientacionsexual || '',
            per_identidadgenero: data?.per_identidadgenero || '',
            etnia: data?.etnia?.toString() || '',
            resguardocomunidad: data?.resguardocomunidad || '',
            dif_2_5_1_1_ceguera: data?.dif_2_5_1_1_ceguera || false,
            dif_2_5_1_2_sordera: data?.dif_2_5_1_2_sordera || false,
            dif_2_5_1_3_mudez: data?.dif_2_5_1_3_mudez || false,
            dif_2_5_1_4_cognitiva_mental: data?.dif_2_5_1_4_cognitiva_mental || false,
            dif_2_5_1_5_paralisisausencia_miemb_sup: data?.dif_2_5_1_5_paralisisausencia_miemb_sup || false,
            dif_2_5_1_6_paralisisausencia_miemb_inf: data?.dif_2_5_1_6_paralisisausencia_miemb_inf || false,
            dif_2_5_2_causa_discapacidad: data?.dif_2_5_2_causa_discapacidad || '',
            obs_discapacidad: data?.obs_discapacidad || '', 
            enfermedadcronicaterminal: data?.enfermedadcronicaterminal?.toString() || '',
            obs_enfterminal: data?.obs_enfterminal || '',
            desaparicion_forzada: data?.desaparicion_forzada || false,
            vict_4_1_1_desaparicion_forzada: data?.vict_4_1_1_desaparicion_forzada || '',
            secuestro: data?.secuestro || false,
            vict_4_1_2_secuestro: data?.vict_4_1_2_secuestro || '',
            desplazamiento_forzado: data?.desplazamiento_forzado || false,
            vict_4_1_3_desplazamiento_forzado: data?.vict_4_1_3_desplazamiento_forzado || '',
            homicidio: data?.homicidio || false,
            vict_4_1_4_homicidio: data?.vict_4_1_4_homicidio || '',
            masacre: data?.masacre || false,
            vict_4_1_5_masacre: data?.vict_4_1_5_masacre || '',
            tortura_o_tratos_inhumanos_degradantes: data?.tortura_o_tratos_inhumanos_degradantes || false,
            vict_4_1_6_tortura_o_tratos_inhumanos_degradantes: data?.vict_4_1_6_tortura_o_tratos_inhumanos_degradantes || '',
            lesiones_permanentes_o_transitorias: data?.lesiones_permanentes_o_transitorias || false,
            vict_4_1_7_lesiones_permanentes_o_transitorias: data?.vict_4_1_7_lesiones_permanentes_o_transitorias || '',
            minas_antipersonal_municiones_sin_explotar: data?.minas_antipersonal_municiones_sin_explotar || false,
            vict_4_1_8_minas_antipersonal_municiones_sin_explotar: data?.vict_4_1_8_minas_antipersonal_municiones_sin_explotar || '',
            delitos_contra_la_libertad_y_la_integridad_sexual: data?.delitos_contra_la_libertad_y_la_integridad_sexual || false,
            vict_4_1_9_delitos_contra_la_libertad_y_la_integridad_sexual: data?.vict_4_1_9_delitos_contra_la_libertad_y_la_integridad_sexual || '',
            intento_de_reclutamiento: data?.intento_de_reclutamiento || false,
            vict_4_1_10_1_intento_de_reclutamiento: data?.vict_4_1_10_1_intento_de_reclutamiento || '',
            reclutamiento_y_utilizacion: data?.reclutamiento_y_utilizacion || false,
            vict_4_1_10_2_reclutamiento_y_utilizacion: data?.vict_4_1_10_2_reclutamiento_y_utilizacion || '',
            acto_terrorista: data?.acto_terrorista || false,
            vict_4_1_11_acto_terrorista: data?.vict_4_1_11_acto_terrorista || '',
            amenaza: data?.amenaza || false,
            vict_4_1_12_amenaza: data?.vict_4_1_12_amenaza || '',
            despojo_y_abandono_forzado_de_tierras: data?.despojo_y_abandono_forzado_de_tierras || false,
            vict_4_1_13_despojo_y_abandono_forzado_de_tierras: data?.vict_4_1_13_despojo_y_abandono_forzado_de_tierras || '',
            fuerza_mayor: data?.fuerza_mayor || '',
            lgbti: data?.lgbti || false,
            gestantelactante: data?.gestantelactante || '',
            estasindocumento: data?.estasindocumento || false,
            tipodocderecho: data?.tipodocderecho || '',
            situacionriesgo: data?.situacionriesgo || false,
            condicionriesgo: data?.condicionriesgo || '',
            denuncioriesgo: data?.denuncioriesgo || false,
            donde_obtenia_ingresos: data?.donde_obtenia_ingresos || '0',
            generabaingresos: data?.donde_obtenia_ingresos !== 0,
            cual_actividad_obtenia_ingresos: data?.cual_actividad_obtenia_ingresos || '',
            esgeneradodeingresosenhogar: data?.esgeneradodeingresosenhogar || false,
            dondeprovieneningresos: data?.dondeprovieneningresos || '',
            atividadeeconomica: data?.atividadeeconomica || '',
            tienesisben: data?.tienesisben || false,
            departamentosisben: data?.departamentosisben || '',
            municipiosisben: data?.municipiosisben || '',
            tienefosyga: data?.tienefosyga || false,
            regimenfosyga: data?.regimenfosyga?.toString() || '',
            departamentofosyga: data?.departamentofosyga || '',
            municipiofosyga: data?.municipiofosyga || '',
            estudiaactualmente: data?.estudiaactualmente || false,
            recibiratencionpsicosocial: data?.recibiratencionpsicosocial || false,
            recibiratencionjuridica: data?.recibiratencionjuridica || false,
        }));
        

        // 4. SISBEN municipios
        setMunicipiosAndValue(
            data?.departamentosisben,
            municipios,
            setMunicipiosSisben,
            setValue,
            'municipiosisben',
            data?.municipiosisben
        );

        // 5. FOSYGA municipios
        setMunicipiosAndValue(
            data?.departamentofosyga,
            municipios,
            setMunicipiosFosyga,
            setValue,
            'municipiofosyga',
            data?.municipiofosyga
        );
    }, [municipios, paises, reset]);

    const setArrayOrEmpty = (data, setter, label) => {
        if (Array.isArray(data)) {
            setter(data);
        } else {
            console.error(`Invalid data for ${label}:`, data);
            setter([]);
        }
    };

    useEffect(() => {
        if (pendingResetData && paises.length > 0) {
            FormReset(pendingResetData);
            setPendingResetData(null);
        }
    }, [pendingResetData, paises, FormReset]);

    const InicializarFormulario = useCallback(async () => {
            const url = '/diagnostico/integrante/crearformulariointegrante';
            const obj = { idDx: iddx, idPersona: idpersona, idrecepcion: idrecepcion };
            try {
                
                setCargando(true);
                const response = await apiService.post(url, obj, token);
                const result = await response.data;
                setCantidadIntegrantes(result.recepcion.cantidadintegrantes ?? 0);
                setFechaInicioAtencion(result.recepcion.rep_fechahoraatencion ?? null);
                setArrayOrEmpty(result.tiposdocumento, setTiposDocumento, 'tiposdocumento');
                setArrayOrEmpty(result.tiposdocumentoextranjero, setTiposDocumentoExtranjeria, 'tiposdocumentoextranjero');
                setArrayOrEmpty(result.tiposdocumentoregistraduria, setTiposDocumentoExtranjeria, 'tiposdocumentoregistraduria');
                setArrayOrEmpty(result.parentescos, setParentescos, 'parentescos');
                setArrayOrEmpty(result.sexos, setSexos, 'sexos');
                setArrayOrEmpty(result.orientacionesSexuales, setOrientacionesSexuales, 'orientacionesSexuales');
                setArrayOrEmpty(result.identidadesGenero, setIdentidadesGenero, 'identidadesGenero');
                setArrayOrEmpty(result.gestantes, setGestantes, 'gestantes');
                setArrayOrEmpty(result.etnias, setEtnias, 'etnias');
                setArrayOrEmpty(result.discapacidadcausas, setDiscapacidadCausas, 'discapacidadcausas');
                setArrayOrEmpty(result.enfermedades, setEnfermedades, 'enfermedades');
                setArrayOrEmpty(result.condicionesriesgo, setCondicionesRiesgo, 'condicionesriesgo');
                setArrayOrEmpty(result.ingresosprovenientes, setIngresosProvenientes, 'ingresosprovenientes');
                setArrayOrEmpty(result.regimenfosyga, setRegimenFosyga, 'regimenfosyga');
                setArrayOrEmpty(result.paises, setPaises, 'paises');

                setPendingResetData(result.integrante ?? result.recepcion);
            } catch (error) {
                console.error('Error fetching data:', error);
            } finally {
                setCargando(false);
            }
        }, [iddx, idpersona, idrecepcion, token]);
    useEffect(() => {
        getMunicipiosDXData();
    }, [getMunicipiosDXData]);
    
    const ConfigurarParentesco = useCallback((parentesco) => {
        if(parentesco === '1'){
            setParentescosFiltro(parentescos.filter((parentesco) => parentesco.id === '1'));
        } else if(cantidadIntegrantes <= 0) {
            setParentescosFiltro(parentescos.filter((parentesco) => parentesco.id === '1'));
        } else {
            setParentescosFiltro(parentescos.filter((parentesco) => parentesco.id !== '1'));
        }
    }, [parentescos, cantidadIntegrantes]);
    useEffect(() => {
        ConfigurarParentesco(watch('parentesco').toString());
    }, [ConfigurarParentesco, watch]);
    
    useEffect(() => {
        if (municipios.length > 0) {
            setDepartamentosSisben([
                ...new Map(
                    municipios.map((municipio) => [
                        municipio.mun_departamentoid,
                        { id: municipio.mun_departamentoid, name: municipio.mun_departamento },
                    ])
                ).values(),
            ]);
            setDepartamentosFosyga([
                ...new Map(
                    municipios.map((municipio) => [
                        municipio.mun_departamentoid,
                        { id: municipio.mun_departamentoid, name: municipio.mun_departamento },
                    ])
                ).values(),
            ]);
        }
        InicializarFormulario();
    }, [municipios, InicializarFormulario])
    async function EliminarPersona(id){
        setCargando(true);
        const result = await SweetAlert.fire({
            title: '¿Confirma que desea eliminar a esta persona?',
            text: 'Esta acción no se puede deshacer.',
            icon: 'warning',
            showCancelButton: true,
            confirmButtonText: 'Sí, eliminar',
            cancelButtonText: 'Cancelar',
            reverseButtons: true,
        });
        if (!result.isConfirmed) {
            setCargando(false);
            return;
        }
        setBtnGuardarDisabled(true);
        const url = '/diagnostico/integrante/eliminarintegrante';
        try {
            const response = await apiService.post(url, { id }, token);
            if (response.status === 200) {
                irAHogar();
            }
        } catch (error) {
            handleApiError(error);
        } finally {
            setCargando(false);
            setBtnGuardarDisabled(false);
        }
    }
    return (
        
        <div className="content-wrapper">
            <SeccionPageHeader
                title="Diagnostico base - Hogar - Integrante"
                idCabezaFamilia={iddx}
                url={`/dx/hogar/${iddx}`}
                nombreurl="Hogar"
                nombreform="Integrante"
            />
            <CargandoSpinner Cargando={Cargando} />
            <section className="content">
                <div className="container-fluid">
                    <HeaderDXReloj startTime={fechaInicioAtencion} estadoDx={'8'} />
                    <MenuEnlacesDX iddx={iddx} idrecepcion={idrecepcion} buttonActive={2}/>
                </div>
                <div className="row">
                    <div className="col-md-12">
                        <div className="tab-content">
                            <div className="card card-info">
                                <div className="card-header">
                                    <h3 className="card-title">Registro de integrante</h3>
                                </div>
                                <form className="form-horizontal" onSubmit={handleSubmit(onSubmit)}>
                                    <div className="card-body">
                                        <div className="row">
                                            <div className="col-md-4">
                                                <p>Id Diagnostico <strong>{iddx}</strong>, Id persona <strong>{watch('id') > 0 && watch('id')}</strong></p>
                                            </div>
                                        </div>
                                        <div className="row" >
                                            <div className="col-md-3">
                                                <div className="form-group">
                                                <label htmlFor="tipodoc">Tipo de documento</label>
                                                <select
                                                    className="form-control"
                                                    id="tipodoc"
                                                    style={{ width: "100%" }}
                                                    {...register("tipodoc", { required: "Este campo es obligatorio" })}
                                                >
                                                    <option value="">Seleccione opci&oacute;n</option>
                                                    {tiposDocumento.map((tipo) => (
                                                        <option key={tipo.id} value={tipo.id}>
                                                            {tipo.tip_tipoidentificacion}-{tipo.tip_descripcion}
                                                        </option>
                                                    ))}
                                                </select>
                                                {errors.tipodoc && (
                                                    <span className="text-danger">{errors.tipodoc.message}</span>
                                                )}
                                                </div>
                                            </div>
                                            <div hidden id="divTipoDocExtranjero" className="col-md-3">
                                                <div className="form-group">
                                                <label htmlFor='tipodocextranjero'>Tipo documento Extranjer&iacute;a</label>
                                                <select
                                                    className="form-control"
                                                    id="tipodocextranjero"
                                                    style={{ width: "100%" }}
                                                    {...register("tipodocextranjero")}
                                                    onChange={(e) => {
                                                       setValue("tipodocextranjero", e.target.value);
                                                    }}
                                                >
                                                    <option value="">Seleccione opci&oacute;n</option>
                                                    {tiposDocumentoExtranjeria.map((tipo) => (
                                                        <option key={tipo.id} value={tipo.id}>
                                                            {tipo.tip_tipoidentificacion}-{tipo.tip_descripcion}
                                                        </option>
                                                    ))}
                                                </select>                                        
                                                {errors.tipodocextranjero && (
                                                    <span className="text-danger">{errors.tipodocextranjero.message}</span>
                                                )}
                                                </div>
                                            </div>
                                            <div id="divPaisOrigen" className="col-md-3">
                                                <div className="form-group">
                                                <label htmlFor='slcintpais'>Pa&iacute;s de origen</label>
                                                <select
                                                    className="form-control"
                                                    id="slcintpais"
                                                    style={{ width: "100%" }}
                                                    {...register("slcintpais")}
                                                    onChange={(e) => {
                                                        setValue("pais_origen", paises.find(pais => pais.id === e.target.value)?.pais || '');
                                                        setValue("slcintpais", e.target.value);
                                                    }}
                                                >
                                                    <option value="">Seleccione opci&oacute;n</option>
                                                    {paises.map((pais) => (
                                                        <option key={pais.id} value={pais.id}>
                                                            {pais.iso}-{pais.pais}
                                                        </option>
                                                    ))}
                                                </select>
                                                {errors.slcintpais && <span className="text-danger">{errors.slcintpais.message}</span>}
                                                <input
                                                    hidden
                                                    maxLength="30"
                                                    className="form-control"
                                                    id="pais_origen"
                                                    placeholder="Pais origen"
                                                    {...register("pais_origen")}
                                                />
                                                {errors.pais_origen && <span className="text-danger">{errors.pais_origen.message}</span>}
                                                </div>  
                                            </div>
                                            <div className="col-md-3">
                                                <div className="form-group">
                                                <label htmlFor="numdoc">Numero documento</label>
                                                <input
                                                    type="text"
                                                    maxLength="20"
                                                    className="form-control"
                                                    id="numdoc"
                                                    placeholder="Numero documento"
                                                    {...register("numdoc", { 
                                                        required: "Este campo es obligatorio",
                                                        validate: value => value && value !== "0" ? true : "El número de documento no puede ser 0 ni estar vacío"
                                                    })}
                                                />
                                                {errors.numdoc && <span className="text-danger">{errors.numdoc.message}</span>}
                                                </div>  
                                            </div>
                                        </div>
                                        <div className="row">
                                            <div className="col-md-3">
                                                <div className="form-group">
                                                    <div className="custom-control custom-switch">
                                                    <input type="checkbox" 
                                                        {...register('estasindocumento')}
                                                        onChange={(e) => {
                                                            setValue("estasindocumento", e.target.checked)
                                                            setValue("tipodocderecho", '');
                                                        }}
                                                        className="custom-control-input" id="estasindocumento"/>
                                                    <label className="custom-control-label" htmlFor="estasindocumento">Esta sin documento</label>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        {watch("estasindocumento") && <div className="row">
                                            <div className="col-md-3">                                            
                                                    <span id="infochkestaSinDocumento">Es necesario que el jefe de hogar asista al tramite de derecho a la identidad.</span>
                                                    
                                            </div>
                                            <div className="col-md-4">
                                                <div className="form-group">
                                                <label htmlFor='tipodocderecho'>Que tipo de documento le hace falta?</label>
                                                <select
                                                    className="form-control"
                                                    id="tipodocderecho"
                                                    style={{ width: "100%" }}
                                                    {...register("tipodocderecho", { required: watch('estasindocumento') ? "Debe seleccionar un tipo de documento" : false })}
                                                    disabled={!watch("estasindocumento")}
                                                >
                                                    {tiposDocumentoExtranjeria.map((tipo) => (
                                                        <option key={tipo.id} value={tipo.id}>
                                                            {tipo.tip_tipoidentificacion} {tipo.tip_descripcion}
                                                        </option>
                                                    ))}
                                                </select>
                                                {errors.tipodocderecho && (
                                                    <span className="text-danger">{errors.tipodocderecho.message}</span>
                                                )}
                                                </div>
                                            </div>
                                        </div>}
                                        <div className="row" >
                                            <div className="col-md-3">
                                                <div className="form-group">
                                                <label htmlFor="pnombre">Primer nombre</label>
                                                <input
                                                    type="text"
                                                    maxLength="30"
                                                    className="form-control"
                                                    id="pnombre"
                                                    placeholder="Nombre"
                                                    {...register("pnombre", { required: "Este campo es obligatorio" })}
                                                />
                                                {errors.pnombre && <span className="text-danger">{errors.pnombre.message}</span>}
                                                </div>  
                                            </div>
                                            <div className="col-md-3">
                                                <div className="form-group">
                                                <label htmlFor="snombre">Segundo Nombre</label>
                                                <input
                                                    type="text"
                                                    maxLength="30"
                                                    className="form-control"
                                                    id="snombre"
                                                    placeholder="Segundo Nombre"
                                                    {...register("snombre")}
                                                />
                                                {errors.snombre && <span className="text-danger">{errors.snombre.message}</span>}
                                                </div>  
                                            </div>
                                            <div className="col-md-3">
                                                <div className="form-group">
                                                <label htmlFor="papellido">Primer apellido</label>
                                                <input
                                                    type="text"
                                                    maxLength="30"
                                                    className="form-control"
                                                    id="papellido"
                                                    placeholder="Primer Apellido"
                                                    {...register("papellido", { required: "Este campo es obligatorio" })}
                                                />
                                                {errors.papellido && <span className="text-danger">{errors.papellido.message}</span>}
                                                </div>  
                                            </div>
                                            <div className="col-md-3">
                                                <div className="form-group">
                                                <label htmlFor="sapellido">Segundo apellido</label>
                                                <input
                                                    type="text"
                                                    maxLength="30"
                                                    className="form-control"
                                                    id="sapellido"
                                                    placeholder="Segundo Apellido"
                                                    {...register("sapellido")}
                                                />
                                                {errors.sapellido && <span className="text-danger">{errors.sapellido.message}</span>}
                                                </div>
                                            </div>
                                            <div className="col-md-4">
                                                <div className="form-group">
                                                <label htmlFor='parentesco'>Parentesco</label>
                                                <select
                                                    className="form-control"
                                                    id="parentesco"
                                                    style={{ width: "100%" }}
                                                    {...register("parentesco", { required: "Este campo es obligatorio" })}
                                                >
                                                    <option value="">Seleccione opci&oacute;n</option>
                                                    {parentescosFiltro.map((parentesco) => (
                                                        <option key={parentesco.id} value={parentesco.id}>
                                                            {parentesco.par_parentesco}
                                                        </option>
                                                    ))}
                                                    
                                                </select>
                                                {errors.slcIntParentesco && (
                                                    <span className="text-danger">{errors.slcIntParentesco.message}</span>
                                                )}
                                                </div> 
                                            </div>
                                        
                                        </div>
                                        <div className="row">
                                            <div className="col-md-3">
                                                <div className="form-group">
                                                        <div className="custom-control custom-switch">
                                                        <input type="checkbox" 
                                                            {...register('noestaenmedellin')}
                                                            onChange={(e) => {
                                                                setValue("noestaenmedellin", e.target.checked)
                                                            }}
                                                            className="custom-control-input" id="noestaenmedellin"
                                                            disabled={watch('parentesco') === '1'}
                                                            />
                                                        <label className="custom-control-label" htmlFor="noestaenmedellin"> ¿Esta persona no est&aacute; en Medell&iacute;n?</label>
                                                        </div>
                                                    </div>
                                            </div>
                                        </div>
                                        <div className="row">
                                        <div className="col-md-2">
                                            <div className="form-group">
                                            <label htmlFor='txtIntFechaNacimiento'>Fecha de Nacimiento</label>
                                            <div className="input-group">
                                                <Controller
                                                    control={control}
                                                    name="fecha_nacimiento"
                                                    render={({ field }) => (
                                                        <div style={{ border: '1px solid #ced4da', borderRadius: 4, padding: 2, display: 'inline-block' }}>
                                                            <DatePicker
                                                            placeholderText="fecha"
                                                            onChange={(date) => {field.onChange(date); CalcularEdad(date);}}
                                                            showMonthDropdown
                                                            showYearDropdown
                                                            dropdownMode="select"
                                                            selected={field.value ? new Date(`${field.value}`) : null}
                                                            customInput={<CustomInput />}
                                                            locale="es"
                                                            dateFormat="yyyy-MM-dd"
                                                            maxDate={new Date()}
                                                            />
                                                        </div>
                                                    )}
                                                />
                                                {errors.fecha_nacimiento && <p style={{color: 'red'}}>Seleccione fecha nacimiento</p>}
                                            </div>
                                            </div>
                                        </div>
                                        <div className="col-md-1">
                                            <div className="form-group">
                                            <label htmlFor="edad">Edad</label>
                                            <input disabled type="text" maxLength="3" className="form-control" id="edad" {...register('edad')} placeholder="0"/>
                                            </div>  
                                        </div>
                                        <div className="col-md-2">
                                            <div className="form-group">
                                                <label htmlFor='sexo'>Sexo</label>
                                                <select
                                                    className="form-control"
                                                    id="sexo"
                                                    style={{ width: "100%" }}
                                                    {...register("sexo", { required: "Este campo es obligatorio" })}
                                                    onChange={(e) => {
                                                        if (e.target.value !== '2') {
                                                            setValue("gestantelactante", '');
                                                        }
                                                        setValue("sexo", e.target.value);
                                                    }}
                                                >
                                                    <option value="">Seleccione opci&oacute;n</option>
                                                    {sexos.map((sexo) => (
                                                        <option key={sexo.id} value={sexo.id}>
                                                            {sexo.sex_nombre}
                                                        </option>
                                                    ))}
                                                </select>
                                                {errors.sexo && <span className="text-danger">{errors.sexo.message}</span>}
                                            </div> 
                                        </div>
                                        <div className="col-md-3">
                                            <div className="form-group">
                                                <label htmlFor='per_orientacionsexual'>Orientaci&oacute;n Sexual</label>
                                                <select
                                                    className="form-control"
                                                    id="per_orientacionsexual"
                                                    style={{ width: "100%" }}
                                                    {...register("per_orientacionsexual", { required: "Este campo es obligatorio" })}
                                                >
                                                    <option value="">Seleccione opci&oacute;n</option>
                                                    {orientacionesSexuales.map((orientacion) => (
                                                        <option key={orientacion.id} value={orientacion.id}>
                                                            {orientacion.ori_orientacionsexual}
                                                        </option>
                                                    ))}
                                                </select>
                                                {errors.per_orientacionsexual && <span className="text-danger">{errors.per_orientacionsexual.message}</span>}
                                            </div>
                                        </div>
                                        <div className="col-md-3">
                                            <div className="form-group">
                                                <label htmlFor='per_identidadgenero'>Identidad de G&eacute;nero</label>
                                                <select
                                                    className="form-control"
                                                    id="per_identidadgenero"
                                                    style={{ width: "100%" }}
                                                    {...register("per_identidadgenero", { required: "Este campo es obligatorio" })}
                                                >
                                                    <option value="">Seleccione opci&oacute;n</option>
                                                    {identidadesGenero.map((identidad) => (
                                                        <option key={identidad.id} value={identidad.id}>
                                                            {identidad.ide_identidad}
                                                        </option>
                                                    ))}
                                                </select>
                                                {errors.per_identidadgenero && <span className="text-danger">{errors.per_identidadgenero.message}</span>}
                                            </div>
                                        </div>
                                        <div className="col-md-3">
                                            <div className="form-group">
                                                <div className="custom-control custom-switch">
                                                <input type="checkbox" 
                                                    {...register('lgbti')}
                                                    onChange={(e) => {
                                                        setValue("lgbti", e.target.checked)
                                                    }}
                                                    className="custom-control-input" id="lgbti"/>
                                                <label className="custom-control-label" htmlFor="lgbti"> ¿Pertenece a poblaci&oacute;n OSIEGD?</label>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="row">
                                        <div className="col-md-4">
                                            <div className="form-group">
                                            <label htmlFor='gestantelactante'>¿Es Gestante y/o Lactante?</label>
                                            <select
                                                className="form-control"
                                                id="gestantelactante"
                                                style={{ width: "100%" }}
                                                {...register("gestantelactante", { 
                                                    required: watch('sexo') === '2'? "Este campo es obligatorio" : false,
                                                })}
                                                disabled={watch('sexo') !== '2'}
                                            >
                                                <option value="">Seleccione opci&oacute;n</option>
                                                {gestantes.map((gestante) => (
                                                    <option key={gestante.id} value={gestante.id}>
                                                        {gestante.nombre}
                                                    </option>
                                                ))}
                                            </select>
                                            {errors.gestantelactante && (
                                                <span className="text-danger">{errors.gestantelactante.message}</span>
                                            )}
                                            </div>
                                        </div>
                                        <div className="col-md-6">
                                            <div className="form-group">
                                            <label htmlFor='slcintdif_2_3_etnia'>Etnia</label>
                                            <select
                                                className="form-control"
                                                id="slcintdif_2_3_etnia"
                                                style={{ width: "100%" }}
                                                {...register("etnia", { required: "Este campo es obligatorio" })}
                                                onChange={(e) => {
                                                    if(e.target.value !== '2') {
                                                        setValue("resguardocomunidad", '');
                                                    }
                                                    setValue("etnia", e.target.value);
                                                }}
                                            >
                                                <option value="">Seleccione etnia</option>
                                                {etnias.map((etnia) => (
                                                    <option key={etnia.id} value={etnia.id}>
                                                        {etnia.id} {etnia.min_minoria}
                                                    </option>
                                                ))}
                                                
                                            </select>
                                            {errors.etnia && <span className="text-danger">{errors.etnia.message}</span>}
                                            <span  id="infoslcintdif_2_3_etnia">Una persona pertenece a una etnia, cuando se reconoce como tal.</span>
                                            </div>
                                        </div>
                                        <div className="col-md-6">
                                            <div className="form-group">
                                            <label htmlFor='txtintdif_2_3_1_resguardo_o_comunidad'>Resguardo o Comunidad a la que pertenece</label>
                                            <input
                                                type="text"
                                                maxLength="120"
                                                className="form-control"
                                                id="resguardocomunidad"
                                                placeholder="Resguardo o comunidad"
                                                {...register("resguardocomunidad", { required: watch('etnia') === '2' ? "Este campo es obligatorio" : false })}
                                                disabled={watch('etnia') !== '2'}
                                            />
                                            {errors.resguardocomunidad && <span className="text-danger">{errors.resguardocomunidad.message}</span>}
                                            <span  id="infotxtintdif_2_3_1_resguardo_o_comunidad">Nombre del Resguardo o Comunidad a la que pertenece.</span>
                                            </div>  
                                        </div>
                                        </div>
                                        <div className="row" >
                                        <div className="col-md-6">
                                            <div className="checkbox">
                                                <div className="form-group">
                                                    <div className="custom-control custom-switch">
                                                    <input type="checkbox" 
                                                        {...register('dif_2_5_1_1_ceguera')}
                                                        onChange={(e) => {
                                                            setValue("dif_2_5_1_1_ceguera", e.target.checked)
                                                            checkCausaDiscapacidad(e.target.checked)
                                                        }}
                                                        className="custom-control-input" id="dif_2_5_1_1_ceguera"/>
                                                    <label className="custom-control-label" htmlFor="dif_2_5_1_1_ceguera"> Ceguera</label>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="checkbox">
                                                <div className="form-group">
                                                    <div className="custom-control custom-switch">
                                                    <input type="checkbox" 
                                                        {...register('dif_2_5_1_2_sordera')}
                                                        onChange={(e) => {
                                                            setValue("dif_2_5_1_2_sordera", e.target.checked)
                                                            checkCausaDiscapacidad(e.target.checked)
                                                        }}
                                                        className="custom-control-input" id="dif_2_5_1_2_sordera"/>
                                                    <label className="custom-control-label" htmlFor="dif_2_5_1_2_sordera"> Sordera</label>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="checkbox">
                                                <div className="form-group">
                                                    <div className="custom-control custom-switch">
                                                    <input type="checkbox" 
                                                        {...register('dif_2_5_1_3_mudez')}
                                                        onChange={(e) => {
                                                            setValue("dif_2_5_1_3_mudez", e.target.checked)
                                                            checkCausaDiscapacidad(e.target.checked)
                                                        }}
                                                        className="custom-control-input" id="dif_2_5_1_3_mudez"/>
                                                    <label className="custom-control-label" htmlFor="dif_2_5_1_3_mudez"> Mudez</label>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="checkbox">
                                                <div className="form-group">
                                                    <div className="custom-control custom-switch">
                                                    <input type="checkbox" 
                                                        {...register('dif_2_5_1_4_cognitiva_mental')}
                                                        onChange={(e) => {
                                                            setValue("dif_2_5_1_4_cognitiva_mental", e.target.checked)
                                                            checkCausaDiscapacidad(e.target.checked)
                                                        }}
                                                        className="custom-control-input" id="dif_2_5_1_4_cognitiva_mental"/>
                                                    <label className="custom-control-label" htmlFor="dif_2_5_1_4_cognitiva_mental"> Cognitiva Mental</label>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="checkbox">
                                                <div className="form-group">
                                                    <div className="custom-control custom-switch">
                                                    <input type="checkbox" 
                                                        {...register('dif_2_5_1_5_paralisisausencia_miemb_sup')}
                                                        onChange={(e) => {
                                                            setValue("dif_2_5_1_5_paralisisausencia_miemb_sup", e.target.checked)
                                                            checkCausaDiscapacidad(e.target.checked)
                                                        }}
                                                        className="custom-control-input" id="dif_2_5_1_5_paralisisausencia_miemb_sup"/>
                                                    <label className="custom-control-label" htmlFor="dif_2_5_1_5_paralisisausencia_miemb_sup"> Paralisis ausencia miembros superiores</label>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="checkbox">
                                                <div className="form-group">
                                                    <div className="custom-control custom-switch">
                                                    <input type="checkbox" 
                                                        {...register('dif_2_5_1_6_paralisisausencia_miemb_inf')}
                                                        onChange={(e) => {
                                                            setValue("dif_2_5_1_6_paralisisausencia_miemb_inf", e.target.checked)
                                                            checkCausaDiscapacidad(e.target.checked)
                                                        }}
                                                        className="custom-control-input" id="dif_2_5_1_6_paralisisausencia_miemb_inf"/>
                                                    <label className="custom-control-label" htmlFor="dif_2_5_1_6_paralisisausencia_miemb_inf"> Paralisis ausencia miembros inferiores</label>
                                                    </div>
                                                </div>
                                            </div>  
                                        </div>
                                        <div className="col-md-6">
                                            <div className="row">
                                            <div className="col-md-12">
                                                <div className="form-group">
                                                <label htmlFor='dif_2_5_2_causa_discapacidad'>Causa de la Discapacidad</label>
                                                <select
                                                    className="form-control"
                                                    id="dif_2_5_2_causa_discapacidad"
                                                    style={{ width: "100%" }}
                                                    {...register("dif_2_5_2_causa_discapacidad")}
                                                    disabled={
                                                        !(
                                                            watch("dif_2_5_1_1_ceguera") ||
                                                            watch("dif_2_5_1_2_sordera") ||
                                                            watch("dif_2_5_1_3_mudez") ||
                                                            watch("dif_2_5_1_4_cognitiva_mental") ||
                                                            watch("dif_2_5_1_5_paralisisausencia_miemb_sup") ||
                                                            watch("dif_2_5_1_6_paralisisausencia_miemb_inf")
                                                        )
                                                    }
                                                >
                                                    <option value="">Seleccione causa discapacidad</option>
                                                    {discapacidadCausas.map((causa) => (
                                                        <option key={causa.id} value={causa.id}>
                                                            {causa.id} {causa.dis_causa}
                                                        </option>
                                                    ))}
                                                </select>
                                                {errors.dif_2_5_2_causa_discapacidad && (
                                                    <span className="text-danger">{errors.dif_2_5_2_causa_discapacidad.message}</span>
                                                )}
                                                </div>
                                            </div>
                                            </div>
                                            <div className="row">
                                            <div className="col-md-12">
                                                <div className="form-group">
                                                <label htmlFor='txtintobs_Discapacidad'>Detalle de la discapacidad</label>
                                                    <textarea
                                                        id="obs_discapacidad"
                                                        maxLength="250"
                                                        rows="3"
                                                        className="form-control"
                                                        placeholder="Detalle de la discapacidad"
                                                        {...register("obs_discapacidad", {
                                                            pattern: {
                                                                value: /^[a-zA-Z0-9.,\s]*$/,
                                                                message: "Solo se permiten letras, números, coma y punto"
                                                            }
                                                        })}
                                                        onKeyDown={e => {
                                                            if (e.key === "Enter") e.preventDefault();
                                                        }}
                                                        disabled={
                                                        !(
                                                            watch("dif_2_5_1_1_ceguera") ||
                                                            watch("dif_2_5_1_2_sordera") ||
                                                            watch("dif_2_5_1_3_mudez") ||
                                                            watch("dif_2_5_1_4_cognitiva_mental") ||
                                                            watch("dif_2_5_1_5_paralisisausencia_miemb_sup") ||
                                                            watch("dif_2_5_1_6_paralisisausencia_miemb_inf")
                                                        )
                                                    }
                                                    />
                                                    {errors.obs_discapacidad && <span className="text-danger">{errors.obs_discapacidad.message}</span>}
                                                </div>
                                            </div>    
                                            </div>
                                        </div>
                                        </div>
                                        <div className="row" >
                                        <div className="col-md-6">
                                            <div className="form-group">
                                            <label htmlFor='enfermedadcronicaterminal'>Tiene alg&uacute;n tipo de enfermedad Cr&oacute;nica o Terminal</label>
                                            <select
                                                className="form-control"
                                                id="enfermedadcronicaterminal"
                                                style={{ width: "100%" }}
                                                {...register("enfermedadcronicaterminal", { required: "Este campo es obligatorio" })}
                                                onChange={(e) => {
                                                    if (e.target.value === '3') {
                                                        setValue("obs_enfterminal", '');
                                                    }
                                                    setValue("enfermedadcronicaterminal", e.target.value);
                                                }}
                                            >
                                                <option value="">Seleccione opci&oacute;n</option>
                                                {enfermedades.map((enfermedad) => (
                                                    <option key={enfermedad.id} value={enfermedad.id}>
                                                        {enfermedad.id} {enfermedad.nombre}
                                                    </option>
                                                ))}
                                            </select>
                                            {errors.enfermedadcronicaterminal && (
                                                <span className="text-danger">{errors.enfermedadcronicaterminal.message}</span>
                                            )}
                                            </div>
                                        </div>
                                        <div className="col-md-6">
                                            <div className="form-group">
                                            <label htmlFor='obs_enfterminal'>¿Cual enfermedad?</label>
                                            <textarea
                                                id="obs_enfterminal"
                                                maxLength="250"
                                                rows="2"
                                                className="form-control"
                                                placeholder="Detalle de la enfermedad"
                                                {...register("obs_enfterminal", { 
                                                    required: watch('enfermedadcronicaterminal') !== '3' ? "Este campo es obligatorio" : false,
                                                    pattern: {
                                                        value: /^[a-zA-Z0-9.,\s]*$/,
                                                        message: "Solo se permiten letras, números, coma y punto"
                                                    }
                                                })}
                                                onKeyDown={e => {
                                                    if (e.key === "Enter") e.preventDefault();
                                                }}
                                                disabled={watch('enfermedadcronicaterminal') === '3'}
                                            />
                                            {errors.obs_enfterminal && <span className="text-danger">{errors.obs_enfterminal.message}</span>}
                                            </div>
                                        </div> 
                                        </div>
                                        <div className="row">
                                        
                                        </div>
                                        <div className="row">
                                            <h4 className="card-title"><b>Hecho o Hechos Victimizantes.</b></h4>
                                        </div>
                                        <div className="row">
                                            <div className="col-md-3">
                                                <div className="form-group">
                                                    <div className="custom-control custom-switch">
                                                        <input
                                                            type="checkbox"
                                                            {...register('amenaza')}
                                                            onChange={(e) => {
                                                                setValue("amenaza", e.target.checked);
                                                                if (!e.target.checked) {
                                                                    setValue("vict_4_1_12_amenaza", null);
                                                                }
                                                            }}
                                                            className="custom-control-input"
                                                            id="amenaza"
                                                        />
                                                        <label className="custom-control-label" htmlFor="amenaza">Amenaza</label>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="col-md-3">
                                                {watch("amenaza") && (
                                                    <div className="form-group">
                                                        <label htmlFor="vict_4_1_12_amenaza">Fecha</label>
                                                        <span style={{ margin: "0 5px" }} />
                                                        <Controller
                                                            control={control}
                                                            name="vict_4_1_12_amenaza"
                                                            render={({ field }) => (
                                                                <div style={{ border: '1px solid #ced4da', borderRadius: 4, padding: 2, display: 'inline-block' }}>
                                                                    <DatePicker
                                                                        placeholderText="Seleccione fecha"
                                                                        onChange={(date) => {
                                                                                field.onChange(date);
                                                                                validarFuerzaMayor(date);
                                                                            }}
                                                                        showMonthDropdown
                                                                        showYearDropdown
                                                                        dropdownMode="select"
                                                                        selected={field.value ? new Date(`${field.value}`) : null}
                                                                        customInput={<CustomInput />}
                                                                        locale="es"
                                                                        dateFormat="yyyy-MM-dd"
                                                                        maxDate={new Date()}
                                                                    />
                                                                </div>
                                                            )}
                                                        />
                                                        {errors.vict_4_1_12_amenaza && (
                                                            <p style={{ color: 'red' }}>Seleccione una fecha v&aacute;lida</p>
                                                        )}
                                                    </div>
                                                )}
                                            </div>
                                        </div>
                                        <div className="row" >
                                            <div className="col-md-3">
                                                <div className="form-group">
                                                    <div className="custom-control custom-switch">
                                                        <input
                                                            type="checkbox"
                                                            {...register('secuestro')}
                                                            onChange={(e) => {
                                                                setValue("secuestro", e.target.checked);
                                                                if (!e.target.checked) {
                                                                    setValue("vict_4_1_2_secuestro", null);
                                                                }
                                                            }}
                                                            className="custom-control-input"
                                                            id="secuestro"
                                                        />
                                                        <label className="custom-control-label" htmlFor="secuestro">Secuestro</label>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="col-md-3">
                                                {watch("secuestro") && (
                                                    <div className="form-group">
                                                        <label htmlFor="vict_4_1_2_secuestro">Fecha</label>
                                                        <span style={{ margin: "0 5px" }}/>
                                                        <Controller
                                                            control={control}
                                                            name="vict_4_1_2_secuestro"
                                                            render={({ field }) => (
                                                                <div style={{ border: '1px solid #ced4da', borderRadius: 4, padding: 2, display: 'inline-block' }}>
                                                                    <DatePicker
                                                                        placeholderText="Seleccione fecha"
                                                                        onChange={(date) => {
                                                                                field.onChange(date);
                                                                                validarFuerzaMayor(date);
                                                                            }}
                                                                        showMonthDropdown
                                                                        showYearDropdown
                                                                        dropdownMode="select"
                                                                        selected={field.value ? new Date(`${field.value}`) : null}
                                                                        customInput={<CustomInput />}
                                                                        locale="es"
                                                                        dateFormat="yyyy-MM-dd"
                                                                        maxDate={new Date()}
                                                                    />
                                                                </div>
                                                            )}
                                                        />
                                                        {errors.vict_4_1_2_secuestro && <p style={{ color: 'red' }}>Seleccione una fecha v&aacute;lida</p>}
                                                    </div>
                                                )}
                                            </div>
                                        </div>
                                        <div className="row">
                                            <div className="col-md-3">
                                                <div className="form-group">
                                                    <div className="custom-control custom-switch">
                                                        <input
                                                            type="checkbox"
                                                            {...register('desplazamiento_forzado')}
                                                            onChange={(e) => {
                                                                setValue("desplazamiento_forzado", e.target.checked);
                                                                if (!e.target.checked) {
                                                                    setValue("vict_4_1_3_desplazamiento_forzado", null);
                                                                }
                                                            }}
                                                            className="custom-control-input"
                                                            id="desplazamiento_forzado"
                                                        />
                                                        <label className="custom-control-label" htmlFor="desplazamiento_forzado">Desplazamiento Forzado</label>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="col-md-3">
                                                {watch("desplazamiento_forzado") && (
                                                    <div className="form-group">
                                                        <label htmlFor="vict_4_1_3_desplazamiento_forzado">Fecha</label>
                                                        <span style={{ margin: "0 5px" }} />
                                                        <Controller
                                                            control={control}
                                                            name="vict_4_1_3_desplazamiento_forzado"
                                                            render={({ field }) => (
                                                                <div style={{ border: '1px solid #ced4da', borderRadius: 4, padding: 2, display: 'inline-block' }}>
                                                                    <DatePicker
                                                                        placeholderText="Seleccione fecha"
                                                                        onChange={(date) => {
                                                                                field.onChange(date);
                                                                                validarFuerzaMayor(date);
                                                                            }}
                                                                        showMonthDropdown
                                                                        showYearDropdown
                                                                        dropdownMode="select"
                                                                        selected={field.value ? new Date(`${field.value}`) : null}
                                                                        customInput={<CustomInput />}
                                                                        locale="es"
                                                                        dateFormat="yyyy-MM-dd"
                                                                        maxDate={new Date()}
                                                                    />
                                                                </div>
                                                            )}
                                                        />
                                                        {errors.vict_4_1_3_desplazamiento_forzado && <p style={{ color: 'red' }}>Seleccione una fecha v&aacute;lida</p>}
                                                    </div>
                                                )}
                                            </div>
                                        </div>
                                        <div className="row" >
                                            <div className="col-md-3">
                                                <div className="form-group">
                                                    <div className="custom-control custom-switch">
                                                        <input
                                                            type="checkbox"
                                                            {...register('homicidio')}
                                                            onChange={(e) => {
                                                                setValue("homicidio", e.target.checked);
                                                                if (!e.target.checked) {
                                                                    setValue("vict_4_1_4_homicidio", null);
                                                                }
                                                            }}
                                                            className="custom-control-input"
                                                            id="homicidio"
                                                        />
                                                        <label className="custom-control-label" htmlFor="homicidio">Homicidio</label>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="col-md-3">
                                                {watch("homicidio") && (
                                                    <div className="form-group">
                                                        <label htmlFor="vict_4_1_4_homicidio">Fecha</label>
                                                        <span style={{ margin: "0 5px" }} />
                                                        <Controller
                                                            control={control}
                                                            name="vict_4_1_4_homicidio"
                                                            render={({ field }) => (
                                                                <div style={{ border: '1px solid #ced4da', borderRadius: 4, padding: 2, display: 'inline-block' }}>
                                                                    <DatePicker
                                                                        placeholderText="Seleccione fecha"
                                                                        onChange={(date) => {
                                                                                field.onChange(date);
                                                                                validarFuerzaMayor(date);
                                                                            }}
                                                                        showMonthDropdown
                                                                        showYearDropdown
                                                                        dropdownMode="select"
                                                                        selected={field.value ? new Date(`${field.value}`) : null}
                                                                        customInput={<CustomInput />}
                                                                        locale="es"
                                                                        dateFormat="yyyy-MM-dd"
                                                                        maxDate={new Date()}
                                                                    />
                                                                </div>
                                                            )}
                                                        />
                                                        {errors.vict_4_1_4_homicidio && <p style={{ color: 'red' }}>Seleccione una fecha v&aacute;lida</p>}
                                                    </div>
                                                )}
                                            </div>
                                        </div>
                                        <div className="row">
                                            <div className="col-md-3">
                                                <div className="form-group">
                                                    <div className="custom-control custom-switch">
                                                        <input
                                                            type="checkbox"
                                                            {...register('masacre')}
                                                            onChange={(e) => {
                                                                setValue("masacre", e.target.checked);
                                                                if (!e.target.checked) {
                                                                    setValue("vict_4_1_5_masacre", null);
                                                                }
                                                            }}
                                                            className="custom-control-input"
                                                            id="masacre"
                                                        />
                                                        <label className="custom-control-label" htmlFor="masacre">Masacre</label>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="col-md-3">
                                                {watch("masacre") && (
                                                    <div className="form-group">
                                                        <label htmlFor="vict_4_1_5_masacre">Fecha</label>
                                                        <span style={{ margin: "0 5px" }} />
                                                        <Controller
                                                            control={control}
                                                            name="vict_4_1_5_masacre"
                                                            render={({ field }) => (
                                                                <div style={{ border: '1px solid #ced4da', borderRadius: 4, padding: 2, display: 'inline-block' }}>
                                                                    <DatePicker
                                                                        placeholderText="Seleccione fecha"
                                                                        onChange={(date) => {
                                                                                field.onChange(date);
                                                                                validarFuerzaMayor(date);
                                                                            }}
                                                                        showMonthDropdown
                                                                        showYearDropdown
                                                                        dropdownMode="select"
                                                                        selected={field.value ? new Date(`${field.value}`) : null}
                                                                        customInput={<CustomInput />}
                                                                        locale="es"
                                                                        dateFormat="yyyy-MM-dd"
                                                                        maxDate={new Date()}
                                                                    />
                                                                </div>
                                                            )}
                                                        />
                                                        {errors.vict_4_1_5_masacre && <p style={{ color: 'red' }}>Seleccione una fecha v&aacute;lida</p>}
                                                    </div>
                                                )}
                                            </div>
                                        </div>
                                        <div className="row" >
                                            <div className="col-md-3">
                                                <div className="form-group">
                                                    <div className="custom-control custom-switch">
                                                        <input
                                                            type="checkbox"
                                                            {...register('tortura_o_tratos_inhumanos_degradantes')}
                                                            onChange={(e) => {
                                                                setValue("tortura_o_tratos_inhumanos_degradantes", e.target.checked);
                                                                if (!e.target.checked) {
                                                                    setValue("vict_4_1_6_tortura_o_tratos_inhumanos_degradantes", null);
                                                                }
                                                            }}
                                                            className="custom-control-input"
                                                            id="tortura_o_tratos_inhumanos_degradantes"
                                                        />
                                                        <label className="custom-control-label" htmlFor="tortura_o_tratos_inhumanos_degradantes">
                                                            Tortura o tratos inhumanos degradantes
                                                        </label>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="col-md-3">
                                                {watch("tortura_o_tratos_inhumanos_degradantes") && (
                                                    <div className="form-group">
                                                        <label htmlFor="vict_4_1_6_tortura_o_tratos_inhumanos_degradantes">Fecha</label>
                                                        <span style={{ margin: "0 5px" }} />
                                                        <Controller
                                                            control={control}
                                                            name="vict_4_1_6_tortura_o_tratos_inhumanos_degradantes"
                                                            render={({ field }) => (
                                                                <div style={{ border: '1px solid #ced4da', borderRadius: 4, padding: 2, display: 'inline-block' }}>
                                                                    <DatePicker
                                                                        placeholderText="Seleccione fecha"
                                                                        onChange={(date) => {
                                                                                field.onChange(date);
                                                                                validarFuerzaMayor(date);
                                                                            }}
                                                                        showMonthDropdown
                                                                        showYearDropdown
                                                                        dropdownMode="select"
                                                                        selected={field.value ? new Date(`${field.value}`) : null}
                                                                        customInput={<CustomInput />}
                                                                        locale="es"
                                                                        dateFormat="yyyy-MM-dd"
                                                                        maxDate={new Date()}
                                                                    />
                                                                </div>
                                                            )}
                                                        />
                                                        {errors.vict_4_1_6_tortura_o_tratos_inhumanos_degradantes && (
                                                            <p style={{ color: 'red' }}>Seleccione una fecha v&aacute;lida</p>
                                                        )}
                                                    </div>
                                                )}
                                            </div>
                                        </div>
                                        <div className="row">
                                            <div className="col-md-3">
                                                <div className="form-group">
                                                    <div className="custom-control custom-switch">
                                                        <input
                                                            type="checkbox"
                                                            {...register('lesiones_permanentes_o_transitorias')}
                                                            onChange={(e) => {
                                                                setValue("lesiones_permanentes_o_transitorias", e.target.checked);
                                                                if (!e.target.checked) {
                                                                    setValue("vict_4_1_7_lesiones_permanentes_o_transitorias", null);
                                                                }
                                                            }}
                                                            className="custom-control-input"
                                                            id="lesiones_permanentes_o_transitorias"
                                                        />
                                                        <label className="custom-control-label" htmlFor="lesiones_permanentes_o_transitorias">
                                                            Lesiones permanentes o transitorias
                                                        </label>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="col-md-3">
                                                {watch("lesiones_permanentes_o_transitorias") && (
                                                    <div className="form-group">
                                                        <label htmlFor="vict_4_1_7_lesiones_permanentes_o_transitorias">Fecha</label>
                                                        <span style={{ margin: "0 5px" }} />
                                                        <Controller
                                                            control={control}
                                                            name="vict_4_1_7_lesiones_permanentes_o_transitorias"
                                                            render={({ field }) => (
                                                                <div style={{ border: '1px solid #ced4da', borderRadius: 4, padding: 2, display: 'inline-block' }}>
                                                                    <DatePicker
                                                                        placeholderText="Seleccione fecha"
                                                                        onChange={(date) => {
                                                                                field.onChange(date);
                                                                                validarFuerzaMayor(date);
                                                                            }}
                                                                        showMonthDropdown
                                                                        showYearDropdown
                                                                        dropdownMode="select"
                                                                        selected={field.value ? new Date(`${field.value}`) : null}
                                                                        customInput={<CustomInput />}
                                                                        locale="es"
                                                                        dateFormat="yyyy-MM-dd"
                                                                        maxDate={new Date()}
                                                                    />
                                                                </div>
                                                            )}
                                                        />
                                                        {errors.vict_4_1_7_lesiones_permanentes_o_transitorias && (
                                                            <p style={{ color: 'red' }}>Seleccione una fecha v&aacute;lida</p>
                                                        )}
                                                    </div>
                                                )}
                                            </div>
                                        </div>
                                        <div className="row" >
                                            <div className="col-md-3">
                                                <div className="form-group">
                                                    <div className="custom-control custom-switch">
                                                        <input
                                                            type="checkbox"
                                                            {...register('minas_antipersonal_municiones_sin_explotar')}
                                                            onChange={(e) => {
                                                                setValue("minas_antipersonal_municiones_sin_explotar", e.target.checked);
                                                                if (!e.target.checked) {
                                                                    setValue("vict_4_1_8_minas_antipersonal_municiones_sin_explotar", null);
                                                                }
                                                            }}
                                                            className="custom-control-input"
                                                            id="minas_antipersonal_municiones_sin_explotar"
                                                        />
                                                        <label className="custom-control-label" htmlFor="minas_antipersonal_municiones_sin_explotar">
                                                            Minas antipersonal, municiones sin explotar
                                                        </label>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="col-md-3">
                                                {watch("minas_antipersonal_municiones_sin_explotar") && (
                                                    <div className="form-group">
                                                        <label htmlFor="vict_4_1_8_minas_antipersonal_municiones_sin_explotar">Fecha</label>
                                                        <span style={{ margin: "0 5px" }} />
                                                        <Controller
                                                            control={control}
                                                            name="vict_4_1_8_minas_antipersonal_municiones_sin_explotar"
                                                            render={({ field }) => (
                                                                <div style={{ border: '1px solid #ced4da', borderRadius: 4, padding: 2, display: 'inline-block' }}>
                                                                    <DatePicker
                                                                        placeholderText="Seleccione fecha"
                                                                        onChange={(date) => {
                                                                                field.onChange(date);
                                                                                validarFuerzaMayor(date);
                                                                            }}
                                                                        showMonthDropdown
                                                                        showYearDropdown
                                                                        dropdownMode="select"
                                                                        selected={field.value ? new Date(`${field.value}`) : null}
                                                                        customInput={<CustomInput />}
                                                                        locale="es"
                                                                        dateFormat="yyyy-MM-dd"
                                                                        maxDate={new Date()}
                                                                    />
                                                                </div>
                                                            )}
                                                        />
                                                        {errors.vict_4_1_8_minas_antipersonal_municiones_sin_explotar && (
                                                            <p style={{ color: 'red' }}>Seleccione una fecha v&aacute;lida</p>
                                                        )}
                                                    </div>
                                                )}
                                            </div>
                                        </div>
                                        <div className="row">
                                            <div className="col-md-3">
                                                <div className="form-group">
                                                    <div className="custom-control custom-switch">
                                                        <input
                                                            type="checkbox"
                                                            {...register('delitos_contra_la_libertad_y_la_integridad_sexual')}
                                                            onChange={(e) => {
                                                                setValue("delitos_contra_la_libertad_y_la_integridad_sexual", e.target.checked);
                                                                if (!e.target.checked) {
                                                                    setValue("vict_4_1_9_delitos_contra_la_libertad_y_la_integridad_sexual", null);
                                                                }
                                                            }}
                                                            className="custom-control-input"
                                                            id="delitos_contra_la_libertad_y_la_integridad_sexual"
                                                        />
                                                        <label className="custom-control-label" htmlFor="delitos_contra_la_libertad_y_la_integridad_sexual">
                                                            Delitos contra la libertad y la integridad sexual
                                                        </label>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="col-md-3">
                                                {watch("delitos_contra_la_libertad_y_la_integridad_sexual") && (
                                                    <div className="form-group">
                                                        <label htmlFor="vict_4_1_9_delitos_contra_la_libertad_y_la_integridad_sexual">Fecha</label>
                                                        <span style={{ margin: "0 5px" }} />
                                                        <Controller
                                                            control={control}
                                                            name="vict_4_1_9_delitos_contra_la_libertad_y_la_integridad_sexual"
                                                            render={({ field }) => (
                                                                <div style={{ border: '1px solid #ced4da', borderRadius: 4, padding: 2, display: 'inline-block' }}>
                                                                    <DatePicker
                                                                        placeholderText="Seleccione fecha"
                                                                        onChange={(date) => {
                                                                                field.onChange(date);
                                                                                validarFuerzaMayor(date);
                                                                            }}
                                                                        showMonthDropdown
                                                                        showYearDropdown
                                                                        dropdownMode="select"
                                                                        selected={field.value ? new Date(`${field.value}`) : null}
                                                                        customInput={<CustomInput />}
                                                                        locale="es"
                                                                        dateFormat="yyyy-MM-dd"
                                                                        maxDate={new Date()}
                                                                    />
                                                                </div>
                                                            )}
                                                        />
                                                        {errors.vict_4_1_9_delitos_contra_la_libertad_y_la_integridad_sexual && (
                                                            <p style={{ color: 'red' }}>Seleccione una fecha v&aacute;lida</p>
                                                        )}
                                                    </div>
                                                )}
                                            </div>
                                        </div>                                        
                                        <div className="row">
                                            <div className="col-md-3">
                                                <div className="form-group">
                                                    <div className="custom-control custom-switch">
                                                        <input
                                                            type="checkbox"
                                                            {...register('reclutamiento_y_utilizacion')}
                                                            onChange={(e) => {
                                                                setValue("reclutamiento_y_utilizacion", e.target.checked);
                                                                if (!e.target.checked) {
                                                                    setValue("vict_4_1_10_2_reclutamiento_y_utilizacion", null);
                                                                }
                                                            }}
                                                            className="custom-control-input"
                                                            id="reclutamiento_y_utilizacion"
                                                        />
                                                        <label className="custom-control-label" htmlFor="reclutamiento_y_utilizacion">
                                                            Reclutamiento y utilizaci&oacute;n
                                                        </label>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="col-md-3">
                                                {watch("reclutamiento_y_utilizacion") && (
                                                    <div className="form-group">
                                                        <label htmlFor="vict_4_1_10_2_reclutamiento_y_utilizacion">Fecha</label>
                                                        <span style={{ margin: "0 5px" }} />
                                                        <Controller
                                                            control={control}
                                                            name="vict_4_1_10_2_reclutamiento_y_utilizacion"
                                                            render={({ field }) => (
                                                                <div style={{ border: '1px solid #ced4da', borderRadius: 4, padding: 2, display: 'inline-block' }}>
                                                                    <DatePicker
                                                                        placeholderText="Seleccione fecha"
                                                                        onChange={(date) => {
                                                                                field.onChange(date);
                                                                                validarFuerzaMayor(date);
                                                                            }}
                                                                        showMonthDropdown
                                                                        showYearDropdown
                                                                        dropdownMode="select"
                                                                        selected={field.value ? new Date(`${field.value}`) : null}
                                                                        customInput={<CustomInput />}
                                                                        locale="es"
                                                                        dateFormat="yyyy-MM-dd"
                                                                        maxDate={new Date()}
                                                                    />
                                                                </div>
                                                            )}
                                                        />
                                                        {errors.vict_4_1_10_2_reclutamiento_y_utilizacion && (
                                                            <p style={{ color: 'red' }}>Seleccione una fecha v&aacute;lida</p>
                                                        )}
                                                    </div>
                                                )}
                                            </div>
                                        </div>
                                        <div className="row" >
                                            <div className="col-md-3">
                                                <div className="form-group">
                                                    <div className="custom-control custom-switch">
                                                        <input
                                                            type="checkbox"
                                                            {...register('acto_terrorista')}
                                                            onChange={(e) => {
                                                                setValue("acto_terrorista", e.target.checked);
                                                                if (!e.target.checked) {
                                                                    setValue("vict_4_1_11_acto_terrorista", null);
                                                                }
                                                            }}
                                                            className="custom-control-input"
                                                            id="acto_terrorista"
                                                        />
                                                        <label className="custom-control-label" htmlFor="acto_terrorista">
                                                            Acto terrorista
                                                        </label>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="col-md-3">
                                                {watch("acto_terrorista") && (
                                                    <div className="form-group">
                                                        <label htmlFor="vict_4_1_11_acto_terrorista">Fecha</label>
                                                        <span style={{ margin: "0 5px" }} />
                                                        <Controller
                                                            control={control}
                                                            name="vict_4_1_11_acto_terrorista"
                                                            render={({ field }) => (
                                                                <div style={{ border: '1px solid #ced4da', borderRadius: 4, padding: 2, display: 'inline-block' }}>
                                                                    <DatePicker
                                                                        placeholderText="Seleccione fecha"
                                                                        onChange={(date) => {
                                                                                field.onChange(date);
                                                                                validarFuerzaMayor(date);
                                                                            }}
                                                                        showMonthDropdown
                                                                        showYearDropdown
                                                                        dropdownMode="select"
                                                                        selected={field.value ? new Date(`${field.value}`) : null}
                                                                        customInput={<CustomInput />}
                                                                        locale="es"
                                                                        dateFormat="yyyy-MM-dd"
                                                                        maxDate={new Date()}
                                                                    />
                                                                </div>
                                                            )}
                                                        />
                                                        {errors.vict_4_1_11_acto_terrorista && (
                                                            <p style={{ color: 'red' }}>Seleccione una fecha v&aacute;lida</p>
                                                        )}
                                                    </div>
                                                )}
                                            </div>
                                        </div>
                                        <div className="row">
                                            <div className="col-md-3">
                                                <div className="checkbox">
                                                    <div className="form-group">
                                                        <div className="custom-control custom-switch">
                                                        <input type="checkbox" 
                                                            {...register('desaparicion_forzada')}
                                                            onChange={(e) => {
                                                                setValue("desaparicion_forzada", e.target.checked)
                                                            }}
                                                            className="custom-control-input" id="vict_4_1_1_desaparicion_forzada"/>
                                                        <label className="custom-control-label" htmlFor="vict_4_1_1_desaparicion_forzada"> Desaparicion Forzada</label>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="col-md-3">
                                                {watch('desaparicion_forzada') && <div id="divDesaparicion" className="form-group">
                                                    <label htmlFor='vict_4_1_1_desaparicion_forzada'>Fecha</label>
                                                    <span style={{ margin: "0 5px" }}/>
                                                    <Controller
                                                        control={control}
                                                        name="vict_4_1_1_desaparicion_forzada"
                                                        render={({ field }) => (
                                                            <div style={{ border: '1px solid #ced4da', borderRadius: 4, padding: 2, display: 'inline-block' }}>
                                                                <DatePicker
                                                                placeholderText="fecha"
                                                                onChange={(date) => {
                                                                                field.onChange(date);
                                                                                validarFuerzaMayor(date);
                                                                            }}
                                                                showMonthDropdown
                                                                showYearDropdown
                                                                dropdownMode="select"
                                                                selected={field.value ? new Date(`${field.value}`) : null}
                                                                customInput={<CustomInput />}
                                                                locale="es"
                                                                dateFormat="yyyy-MM-dd"
                                                                maxDate={new Date()}
                                                                />
                                                            </div>
                                                        )}
                                                    />
                                                    {errors.vict_4_1_1_desaparicion_forzada && <p style={{color: 'red'}}>Seleccione fecha nacimiento</p>}
                                                </div>}
                                            </div>
                                        </div>
                                        <div className="row">
                                            <div className="col-md-3">
                                                <div className="form-group">
                                                    <div className="custom-control custom-switch">
                                                        <input
                                                            type="checkbox"
                                                            {...register('despojo_y_abandono_forzado_de_tierras')}
                                                            onChange={(e) => {
                                                                setValue("despojo_y_abandono_forzado_de_tierras", e.target.checked);
                                                                if (!e.target.checked) {
                                                                    setValue("vict_4_1_13_despojo_y_abandono_forzado_de_tierras", null);
                                                                }
                                                            }}
                                                            className="custom-control-input"
                                                            id="despojo_y_abandono_forzado_de_tierras"
                                                        />
                                                        <label className="custom-control-label" htmlFor="despojo_y_abandono_forzado_de_tierras">
                                                            Despojo y abandono forzado de tierras
                                                        </label>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="col-md-3">
                                                {watch("despojo_y_abandono_forzado_de_tierras") && (
                                                    <div className="form-group">
                                                        <label htmlFor="vict_4_1_13_despojo_y_abandono_forzado_de_tierras">Fecha</label>
                                                        <span style={{ margin: "0 5px" }} />
                                                        <Controller
                                                            control={control}
                                                            name="vict_4_1_13_despojo_y_abandono_forzado_de_tierras"
                                                            render={({ field }) => (
                                                                <div style={{ border: '1px solid #ced4da', borderRadius: 4, padding: 2, display: 'inline-block' }}>
                                                                    <DatePicker
                                                                        placeholderText="Seleccione fecha"
                                                                        onChange={(date) => {
                                                                                field.onChange(date);
                                                                                validarFuerzaMayor(date);
                                                                            }}
                                                                        showMonthDropdown
                                                                        showYearDropdown
                                                                        dropdownMode="select"
                                                                        selected={field.value ? new Date(`${field.value}`) : null}
                                                                        customInput={<CustomInput />}
                                                                        locale="es"
                                                                        dateFormat="yyyy-MM-dd"
                                                                        maxDate={new Date()}
                                                                    />
                                                                </div>
                                                            )}
                                                        />
                                                        {errors.vict_4_1_13_despojo_y_abandono_forzado_de_tierras && (
                                                            <p style={{ color: 'red' }}>Seleccione una fecha v&aacute;lida</p>
                                                        )}
                                                    </div>
                                                )}
                                            </div>
                                        </div>
                                        <div className="row" >
                                            <div className="col-md-5">
                                                <div className="form-group">
                                                    <div className="custom-control custom-switch">
                                                        <input
                                                            type="checkbox"
                                                            {...register('intento_de_reclutamiento')}
                                                            onChange={(e) => {
                                                                setValue("intento_de_reclutamiento", e.target.checked);
                                                                if (!e.target.checked) {
                                                                    setValue("vict_4_1_10_1_intento_de_reclutamiento", null);
                                                                }
                                                            }}
                                                            className="custom-control-input"
                                                            id="intento_de_reclutamiento"
                                                            disabled={Number.parseInt(watch("edad")) >= 18}
                                                        />
                                                        <label className="custom-control-label" htmlFor="intento_de_reclutamiento">
                                                            Intento de reclutamiento (situaciones de riesgo que no se alcanzan a materializar como reclutamiento)
                                                        </label>
                                                    </div>
                                                    <span id="infochkIntintento_de_reclutamiento">Solo para menores de 18 años.</span>
                                                </div>
                                            </div>
                                            <div className="col-md-3">
                                                {watch("intento_de_reclutamiento") && (
                                                    <div className="form-group">
                                                        <label htmlFor="vict_4_1_10_1_intento_de_reclutamiento">Fecha</label>
                                                        <span style={{ margin: "0 5px" }} />
                                                        <Controller
                                                            control={control}
                                                            name="vict_4_1_10_1_intento_de_reclutamiento"
                                                            render={({ field }) => (
                                                                <div style={{ border: '1px solid #ced4da', borderRadius: 4, padding: 2, display: 'inline-block' }}>
                                                                    <DatePicker
                                                                        placeholderText="Seleccione fecha"
                                                                        onChange={(date) => {
                                                                                field.onChange(date);
                                                                                validarFuerzaMayor(date);
                                                                            }}
                                                                        showMonthDropdown
                                                                        showYearDropdown
                                                                        dropdownMode="select"
                                                                        selected={field.value ? new Date(`${field.value}`) : null}
                                                                        customInput={<CustomInput />}
                                                                        locale="es"
                                                                        dateFormat="yyyy-MM-dd"
                                                                        maxDate={new Date()}
                                                                    />
                                                                </div>
                                                            )}
                                                        />
                                                        {errors.vict_4_1_10_1_intento_de_reclutamiento && (
                                                            <p style={{ color: 'red' }}>Seleccione una fecha v&aacute;lida</p>
                                                        )}
                                                    </div>
                                                )}
                                            </div>
                                        </div>
                                        <div className="row">
                                        <div className="col-md-12">
                                            <div className="form-group">
                                            <label htmlFor='txtintfuerza_mayor'>Fuerza mayor o caso fortuito, hechos de m&aacute;s de 3 meses de ocurrencia.</label>
                                            <textarea
                                                id="fuerza_mayor"
                                                maxLength="250"
                                                rows="2"
                                                className="form-control"
                                                placeholder="Detalle de fuerza mayor o caso fortuito"
                                                {...register("fuerza_mayor", {
                                                    required: watch("chkfuerza_mayor") ? "Este campo es obligatorio" : false,
                                                })}
                                                disabled={!watch("chkfuerza_mayor")}
                                            />
                                            {errors.fuerza_mayor && <span className="text-danger">{errors.fuerza_mayor.message}</span>}
                                            </div>
                                        </div>
                                        </div>
                                        <hr/>
                                        <h4 className="card-title"><b>Medidas de asistencia</b></h4>
                                        <div className="row">
                                        <div className="col-md-12">
                                            <div className="checkbox">
                                                <div className="form-group">
                                                    <div className="custom-control custom-switch">
                                                        <input
                                                            type="checkbox"
                                                            {...register('situacionriesgo')}
                                                            onChange={(e) => {
                                                                if (!e.target.checked) {
                                                                    setValue("condicionriesgo", "");
                                                                    setValue("denuncioriesgo", false);
                                                                }
                                                                setValue("situacionriesgo", e.target.checked);
                                                            }}
                                                            className="custom-control-input"
                                                            id="situacionriesgo"
                                                        />
                                                        <label className="custom-control-label" htmlFor="situacionriesgo">
                                                            ¿Presenta alg&uacute;n riesgo extraordinario o extremo (amenaza fundada en hechos concretos, dirigida directamente a esa persona y que se est&eacute; dando ahora) que este poniendo en peligro su vida?
                                                        </label>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="form-group">
                                            <label htmlFor='slcIntcondicionRiesgo'>Condici&oacute;n del riesgo.</label>
                                            <select
                                                className="form-control"
                                                id="condicionriesgo"
                                                style={{ width: "100%" }}
                                                {...register("condicionriesgo", { required: watch('situacionriesgo') ? "Este campo es obligatorio" : false })}
                                                disabled={!watch('situacionriesgo')}
                                            >
                                                <option value="">Seleccione opci&oacute;n</option>
                                                {condicionesRiesgo.map((condicion) => (
                                                    <option key={condicion.id} value={condicion.id}>
                                                        {condicion.nombre}
                                                    </option>
                                                ))}
                                            </select>
                                            {errors.condicionriesgo && <span className="text-danger">{errors.condicionriesgo.message}</span>}
                                            </div>
                                            <div className="checkbox">
                                                <div className="custom-control custom-switch">
                                                    <input
                                                        type="checkbox"
                                                        className="custom-control-input"
                                                        id="denuncioriesgo"
                                                        {...register("denuncioriesgo")}
                                                        onChange={(e) => setValue("denuncioriesgo", e.target.checked)}
                                                        disabled={!watch('situacionriesgo')}
                                                    />
                                                    <label className="custom-control-label" htmlFor="denuncioriesgo">
                                                        ¿Denunci&oacute; la situaci&oacute;n de riesgo?
                                                    </label>
                                                </div>
                                            </div>
                                        </div>
                                        </div>
                                        <hr/>
                                        <strong>Generaci&oacute;n de ingresos</strong>
                                        <div className="row"  >
                                        
                                        <div className="col-md-6">
                                            <div className="checkbox">
                                                <div className="form-group">
                                                    <div className="custom-control custom-switch">
                                                        <input
                                                            type="checkbox"
                                                            {...register('generabaingresos')}
                                                            onChange={(e) => {
                                                                if (!e.target.checked) {
                                                                    setValue("donde_obtenia_ingresos", "0");
                                                                    setValue("cual_actividad_obtenia_ingresos", "");
                                                                }
                                                                setValue("generabaingresos", e.target.checked);
                                                            }}
                                                            className="custom-control-input"
                                                            id="generabaingresos"
                                                        />
                                                        <label className="custom-control-label" htmlFor="generabaingresos">
                                                            ¿Generaba ingresos en el hogar antes del hecho?
                                                        </label>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="form-group">
                                                <label htmlFor='donde_obtenia_ingresos'>¿De d&oacute;nde obten&iacute;a los ingresos antes del hecho victimizante?</label>
                                                <select
                                                    className="form-control"
                                                    id="slcIntdonde_obtenia_ingresos"
                                                    style={{ width: "100%" }}
                                                    {...register("donde_obtenia_ingresos", { required: watch('generabaingresos') ? "Este campo es obligatorio" : false })}
                                                    disabled={!watch('generabaingresos')}
                                                >
                                                    <option value="0">Seleccione opci&oacute;n</option>
                                                    {ingresosProvenientes.map((ingreso) => (
                                                        <option key={ingreso.id} value={ingreso.id}>
                                                            {ingreso.nombre}
                                                        </option>
                                                    ))}
                                                </select>
                                                {errors.donde_obtenia_ingresos && (
                                                    <span className="text-danger">{errors.donde_obtenia_ingresos.message}</span>
                                                )}
                                            </div>
                                            <div className="form-group">
                                            <label htmlFor="txtIntcual_actividad_obtenia_ingresos">¿Cu&aacute;l actividad?</label>
                                            <input
                                                type="text"
                                                maxLength="60"
                                                className="form-control"
                                                id="txtIntcual_actividad_obtenia_ingresos"
                                                placeholder="Actividad Economica"
                                                {...register("cual_actividad_obtenia_ingresos", { 
                                                    required: watch('generabaingresos') && watch('donde_obtenia_ingresos') != "3" ? "Este campo es obligatorio" : false })}
                                                disabled={!watch('generabaingresos') || watch('donde_obtenia_ingresos') == "3"}
                                            />
                                            {errors.cual_actividad_obtenia_ingresos && (
                                                <span className="text-danger">{errors.cual_actividad_obtenia_ingresos.message}</span>
                                            )}
                                            </div>  
                                        </div>
                                        <div className="col-md-6">
                                            <div className="checkbox">
                                                <div className="form-group">
                                                    <div className="custom-control custom-switch">
                                                        <input
                                                            type="checkbox"
                                                            {...register('esgeneradodeingresosenhogar')}
                                                            onChange={(e) => {
                                                                if (!e.target.checked) {
                                                                    setValue("dondeprovieneningresos", "");
                                                                    setValue("atividadeeconomica", "");
                                                                }
                                                                setValue("esgeneradodeingresosenhogar", e.target.checked);
                                                            }}
                                                            className="custom-control-input"
                                                            id="esgeneradodeingresosenhogar"
                                                        />
                                                        <label className="custom-control-label" htmlFor="esgeneradodeingresosenhogar">
                                                            ¿Genera ingresos actualmente?
                                                        </label>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="form-group">
                                                <label htmlFor='dondeprovieneningresos'>¿De d&oacute;nde provienen los ingresos actualmente?</label>
                                                <select
                                                    className="form-control"
                                                    id="slcIntdondeProvienenIngresos"
                                                    style={{ width: "100%" }}
                                                    {...register("dondeprovieneningresos", { required: watch('esgeneradodeingresosenhogar') ? "Este campo es obligatorio" : false })}
                                                    disabled={!watch('esgeneradodeingresosenhogar')}
                                                >
                                                    <option value="">Seleccione opci&oacute;n</option>
                                                    {ingresosProvenientes.map((ingreso) => (
                                                        <option key={ingreso.id} value={ingreso.id}>
                                                            {ingreso.nombre}
                                                        </option>
                                                    ))}
                                                </select>
                                                {errors.dondeprovieneningresos && (
                                                    <span className="text-danger">{errors.dondeprovieneningresos.message}</span>
                                                )}
                                            </div>
                                            <div className="form-group">
                                                <label htmlFor="txtIntatividadEconomica">¿Cu&aacute;l actividad?</label>
                                                <input
                                                    type="text"
                                                    maxLength="60"
                                                    className="form-control"
                                                    id="txtIntatividadEconomica"
                                                    placeholder="Actividad Economica"
                                                    {...register("atividadeeconomica", { 
                                                        required: watch('esgeneradodeingresosenhogar') && watch('dondeprovieneningresos') != "3"  ? "Este campo es obligatorio" : false 
                                                    })}
                                                    disabled={!watch('esgeneradodeingresosenhogar') || watch('dondeprovieneningresos') == "3"}
                                                />
                                                {errors.atividadeeconomica && (
                                                    <span className="text-danger">{errors.atividadeeconomica.message}</span>
                                                )}
                                            </div>  
                                        </div>
                                        </div>
                                        <div className="row">
                                            <div className="col-md-12">
                                                <div className="checkbox">
                                                    <div className="form-group">
                                                        <div className="custom-control custom-switch">
                                                            <input
                                                                type="checkbox"
                                                                className="custom-control-input"
                                                                id="tienesisben"
                                                                {...register("tienesisben")}
                                                                onChange={(e) => {
                                                                    setValue("tienesisben", e.target.checked);
                                                                    if (!e.target.checked) {
                                                                        setValue("departamentosisben", "");
                                                                        setValue("municipiosisben", "");
                                                                    }
                                                                }}
                                                            />
                                                            <label className="custom-control-label" htmlFor="tienesisben">
                                                                ¿Tiene SISBEN?
                                                            </label>
                                                            {errors.tienesisben && <span className="text-danger">{errors.tienesisben.message}</span>}
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div  className="col-md-4">
                                                <div className="form-group">
                                                    <label htmlFor='slcIntdepartamentoSisben'>Departamento sisben</label>
                                                    <select
                                                        className="form-control"
                                                        id="departamentosisben"
                                                        style={{ width: "100%" }}
                                                        {...register("departamentosisben", { required: watch("tienesisben") ? "Este campo es obligatorio" : false })}
                                                        onChange={(e) => {
                                                            setValue("departamentosisben", e.target.value);
                                                            setValue("municipiosisben", "");
                                                            if (e.target.value) {
                                                                setMunicipiosSisben(
                                                                    municipios.filter((municipio) => municipio.mun_departamentoid === e.target.value)
                                                                    .map((municipio) => ({ id: municipio.id, name: municipio.mun_municipio }))
                                                                );
                                                            }
                                                        }}
                                                        disabled={!watch("tienesisben")}
                                                    >
                                                        <option value="">Seleccione opci&oacute;n</option>
                                                        {departamentosSisben.map((departamento) => (
                                                            <option key={departamento.id} value={departamento.id}>
                                                                {departamento.name}
                                                            </option>
                                                        ))}
                                                    </select>
                                                    {errors.departamentosisben && <span className="text-danger">{errors.departamentosisben.message}</span>}
                                                </div>
                                            </div>
                                            <div className="col-md-4">
                                                <div className="form-group">
                                                    <label htmlFor='slcmunicipioSisben'>Municipio</label>
                                                    <select
                                                        className="form-control"
                                                        id="municipiosisben"
                                                        style={{ width: "100%" }}
                                                        {...register("municipiosisben", { required: watch("tienesisben") ? "Este campo es obligatorio" : false })}
                                                        disabled={!watch("tienesisben")}
                                                    >
                                                        <option value="">Seleccione opci&oacute;n</option>
                                                        {municipiosSisben.map((municipio) => (
                                                            <option key={municipio.id} value={municipio.id}>
                                                                {municipio.name}
                                                            </option>
                                                        ))}
                                                    </select>
                                                    {errors.municipiosisben && <span className="text-danger">{errors.municipiosisben.message}</span>}
                                                </div>
                                            </div>
                                        </div>
                                        <div className="row" >
                                            <div className="col-md-12">
                                                <div className="checkbox">
                                                    <div className="custom-control custom-switch">
                                                        <input
                                                            type="checkbox"
                                                            className="custom-control-input"
                                                            id="tienefosyga"
                                                            {...register("tienefosyga")}
                                                            onChange={(e) => {
                                                                if (!e.target.checked) {
                                                                    setValue("regimenfosyga", "");
                                                                    setValue("departamentofosyga", "");
                                                                    setValue("municipiofosyga", "");
                                                                }
                                                                setValue("tienefosyga", e.target.checked);
                                                            }}
                                                        />
                                                        <label className="custom-control-label" htmlFor="tienefosyga">
                                                            ¿Tiene ADRES?
                                                        </label>
                                                        {errors.tienefosyga && <span className="text-danger">{errors.tienefosyga.message}</span>}
                                                    </div>
                                                    <div className="form-group">
                                                        <label htmlFor="regimenfosyga">R&eacute;gimen</label>
                                                        <select
                                                            className="form-control"
                                                            id="regimenfosyga"
                                                            style={{ width: "100%" }}
                                                            {...register("regimenfosyga", { required: watch("tienefosyga") ? "Este campo es obligatorio" : false })}
                                                            disabled={!watch("tienefosyga")}
                                                        >
                                                            <option value="">Seleccione opci&oacute;n</option>
                                                            {regimenFosyga.map((regimen) => (
                                                                <option key={regimen.id} value={regimen.id}>
                                                                    {regimen.nombre}
                                                                </option>
                                                            ))}
                                                        </select>
                                                        {errors.regimenfosyga && <span className="text-danger">{errors.regimenfosyga.message}</span>}
                                                    </div>
                                                </div>
                                            </div> 
                                            <div  className="col-md-4">
                                                <div className="form-group">
                                                    <label htmlFor='slcIntdepartamentoFosyga'>Departamento fosyga</label>
                                                    <select
                                                        className="form-control"
                                                        id="departamentosisben"
                                                        style={{ width: "100%" }}
                                                        {...register("departamentofosyga", { required: watch("tienefosyga") ? "Este campo es obligatorio" : false })}
                                                        onChange={(e) => {
                                                            setValue("departamentofosyga", e.target.value);
                                                            setValue("municipiofosyga", "");
                                                            if (e.target.value) {
                                                                setMunicipiosFosyga(
                                                                    municipios.filter((municipio) => municipio.mun_departamentoid === e.target.value)
                                                                    .map((municipio) => ({ id: municipio.id, name: municipio.mun_municipio }))
                                                                );
                                                            }
                                                        }}
                                                        disabled={!watch("tienefosyga")}
                                                    >
                                                        <option value="">Seleccione opci&oacute;n</option>
                                                        {departamentosFosyga.map((departamento) => (
                                                            <option key={departamento.id} value={departamento.id}>
                                                                {departamento.name}
                                                            </option>
                                                        ))}
                                                    </select>
                                                    {errors.departamentofosyga && <span className="text-danger">{errors.departamentofosyga.message}</span>}
                                                </div>
                                            </div>
                                            <div className="col-md-4">
                                                <div className="form-group">
                                                    <label htmlFor='slcmunicipioFosyga'>Municipio</label>
                                                    <select
                                                        className="form-control"
                                                        id="municipiofosyga"
                                                        style={{ width: "100%" }}
                                                        {...register("municipiofosyga", { required: watch("tienefosyga") ?  "Este campo es obligatorio" : false })}
                                                        disabled={!watch("tienefosyga")}
                                                    >
                                                        <option value="">Seleccione opci&oacute;n</option>
                                                        {municipiosFosyga.map((municipio) => (
                                                            <option key={municipio.id} value={municipio.id}>
                                                                {municipio.name}
                                                            </option>
                                                        ))}
                                                    </select>
                                                    {errors.municipiofosyga && <span className="text-danger">{errors.municipiofosyga.message}</span>}
                                                </div>
                                            </div>
                                        </div>
                                        <div className="row">
                                        <div className="col-md-12">
                                            <div className="checkbox">
                                                <div className="form-group">
                                                    <div className="custom-control custom-switch">
                                                        <input
                                                            type="checkbox"
                                                            {...register('estudiaactualmente')}
                                                            onChange={(e) => {
                                                                setValue("estudiaactualmente", e.target.checked);
                                                            }}
                                                            className="custom-control-input"
                                                            id="estudiaactualmente"
                                                        />
                                                        <label className="custom-control-label" htmlFor="estudiaactualmente">
                                                            ¿Estudia actualmente?
                                                        </label>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        </div>
                                    </div>
                                    <div className="card-footer">
                                        <div className="row">
                                            <fieldset className="btn-group" aria-label="Basic example">
                                                <button 
                                                    id="btnRegistrarIntegrante" 
                                                    type="submit" 
                                                    className="btn btn-primary"
                                                    disabled={btnGuardarDisabled}
                                                >
                                                    Guardar
                                                </button>
                                                <span style={{ margin: "0 5px" }}/>
                                                {rol === '2' && (
                                                    <>
                                                        <button id="btnEliminarIntegrante" 
                                                            type="button" 
                                                            className="btn btn-primary"
                                                            onClick={() => EliminarPersona(watch('id'))}>Eliminar</button>
                                                        <span style={{ margin: "0 5px" }} />
                                                    </>
                                                )}
                                                <button id="btnCancelarIntegrante" type="button" onClick={irAHogar} className="btn btn-primary">Cancelar</button>
                                            </fieldset>
                                            
                                        </div>
                                    </div>
                                </form>
                            </div>
                            
                        </div>
                    </div>
                </div>
                <SweetAlert2 {...swalProps} 
                    didClose={() => {
                        setSwalProps({})
                    }}/>
                <Tooltip id="tooltiparriba" place="right"/>

            </section>
        </div>
        
    )
  }